import { FilterList } from '@mui/icons-material'
import { ReactElement } from 'react'
import { I18n, Translate2 } from 'common'
import { FilterAppliedCountChip } from '../../../../../../src/features/filterResults/components/FilterAppliedCountChip'
import { ResultsBarButton } from './ResultsBarButton'

interface FilterSortButtonProps {
  filterCount: number
  onClick: () => void
}

export const FilterSortButton = ({
  filterCount,
  onClick,
}: FilterSortButtonProps): ReactElement => (
  <ResultsBarButton
    onClick={onClick}
    aria-label={Translate2('filterAndSortResults')}
  >
    <FilterList />
    <I18n name="filterSort" />
    <FilterAppliedCountChip count={filterCount} />
  </ResultsBarButton>
)
